import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/** Datum- en tijdweergave voor het dashboard, in de taal van de gebruiker en tijdzone Amsterdam. */
export function useOpmaak() {
  const { i18n } = useTranslation();
  const locale = i18n.language?.startsWith('en') ? 'en-GB' : 'nl-NL';
  return useMemo(() => {
    const tijdF = new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Amsterdam' });
    const datumF = new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Europe/Amsterdam' });
    const dagF = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', year: 'numeric' });
    return {
      tijd: (iso: string) => tijdF.format(new Date(iso)),
      datumTijd: (iso: string) => `${datumF.format(new Date(iso))} · ${tijdF.format(new Date(iso))}`,
      /** Kalenderdag YYYY-MM-DD, zonder tijdzoneverschuiving. */
      dag: (yyyyMmDd: string) => {
        const [j, m, d] = yyyyMmDd.split('-').map(Number);
        return dagF.format(new Date(j, m - 1, d));
      },
      /** Resterende tijd als "2 d 5 u" / "5 u 12 m" / "12 m". */
      resterend: (ms: number) => {
        const min = Math.max(0, Math.floor(ms / 60000));
        const d = Math.floor(min / 1440);
        const u = Math.floor((min % 1440) / 60);
        const m = min % 60;
        const [dl, ul] = locale === 'en-GB' ? ['d', 'h'] : ['d', 'u'];
        if (d > 0) return `${d} ${dl} ${u} ${ul}`;
        if (u > 0) return `${u} ${ul} ${m} m`;
        return `${m} m`;
      },
    };
  }, [locale]);
}

/** Vandaag als YYYY-MM-DD in Amsterdam (voor date-inputs en vergelijkingen met gepland_op). */
export const vandaagAmsterdam = () => new Date().toLocaleDateString('en-CA', { timeZone: 'Europe/Amsterdam' });
